import { Icon } from '@devfolioco/genesis';
import { Analytics } from '@devfolioco/helpers';
import React from 'react';
import styled from 'styled-components';
import parseDomain from 'parse-domain';
import { ANALYTICS_TRACKING_EVENTS } from '@constants';

const PROFILE_COLORS = {
  linkedin: '#0077b5',
  github: '#6f6f6f',
  dribbble: '#ea4c89',
  twitter: '#29a6f3',
  medium: '#12100e',
  youtube: '#ff0000',
  stackoverflow: '#f48024',
  behance: '#053eff',
  facebook: '#1877f2',
  instagram: '#c32aa3',
  kaggle: '#29a6f3',
};

export const ProfileIconContainer = styled.a`
  margin: 8px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${props => PROFILE_COLORS[props.profileName] || '#3770ff'};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const getIconName = profileName => {
  const PROFILES = Object.keys(PROFILE_COLORS);
  return PROFILES.includes(profileName) ? profileName : 'globe';
};

/**
 * Renders a link with the profile logo (if one of GitHub, Dribbble, Twitter, or LinkedIn)
 */
const ProfileIcon = ({ name, href, username }) => {
  const profileName = name.replace(/\s/g, '').toLowerCase();
  const parsedDomain = parseDomain(href);
  let hostname = 'Link';
  // Check whether the parsed URL is valid or not, because some URLs
  // are currently valid according to validator.isURL, but are actually not
  // valid and were crashing this component because of that. E.g. - https://www.test
  if (parsedDomain?.tld || parsedDomain?.subdomain || parsedDomain?.domain) {
    const { tld, subdomain, domain } = parsedDomain;
    hostname = [subdomain, domain, tld].filter(t => !!t).join('.');
  }
  const ariaLabelText = `External profile link: ${name === 'Link' ? hostname : name}`;

  const handleProfileLinkClick = () => {
    Analytics.trackEvent(ANALYTICS_TRACKING_EVENTS.OPENED_MY_PROFILE_LINK, {
      name,
      link: href,
      username,
    });
  };

  return (
    <ProfileIconContainer
      profileName={profileName}
      href={href}
      aria-label={ariaLabelText}
      onClick={handleProfileLinkClick}
      target="_blank"
      rel="noreferrer noopener"
    >
      <Icon name={getIconName(profileName)} color="white-0" size="small" />
    </ProfileIconContainer>
  );
};

export default React.memo(ProfileIcon);
